export default __webpack_public_path__ + "static/petits-metiers-debrouillards-bf99f510e7733c93ab2b8a81931b27ae.jpg";